import React from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { NOT_FOUND_TEXT } from "../constants/notFound404Text";
import NotFound404Logo from "./NotFound404Logo";
import colors from "../../../design-system/colors";
import Button from "../../../design-system/Button";

interface NotFound404ContentProps {
  onGoHome: () => void;
}

export default function NotFound404Content({
  onGoHome,
}: NotFound404ContentProps): JSX.Element {
  return (
    <Box
      sx={{
        position: "relative",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "12px",
        textAlign: "center",
      }}
    >
      <NotFound404Logo />

      <Typography
        sx={{
          fontFamily: "Outfit, sans-serif",
          fontWeight: 500,
          fontSize: "100px",
          lineHeight: "1",
          color: colors.neutral.white,
          mt: 1,
        }}
      >
        {NOT_FOUND_TEXT.HEADING}
      </Typography>

      <Typography
        sx={{
          fontFamily: "Outfit, sans-serif",
          fontWeight: 500,
          fontSize: "20px",
          lineHeight: "30px",
          color: colors.neutral.white,
        }}
      >
        {NOT_FOUND_TEXT.SUBHEADING}
      </Typography>

      <Typography
        sx={{
          fontFamily: "Outfit, sans-serif",
          fontWeight: 400,
          fontSize: "16px",
          lineHeight: "1.6",
          color: colors.neutral[700],
          maxWidth: "402px",
        }}
      >
        {NOT_FOUND_TEXT.DESCRIPTION_LINE_1}
        <br />
        {NOT_FOUND_TEXT.DESCRIPTION_LINE_2}
      </Typography>

      <Button onClick={onGoHome} sx={{ mt: 1 }}>
        {NOT_FOUND_TEXT.GO_HOME_BUTTON}
      </Button>
    </Box>
  );
}
